import { render, staticRenderFns } from "./tasks_form.vue?vue&type=template&id=ff187d26&scoped=true&"
import script from "./tasks_form.vue?vue&type=script&lang=js&"
export * from "./tasks_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff187d26",
  null
  
)

export default component.exports